"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.READINESS_GAPS = exports.readinessQuerySchema = exports.readinessListSchema = exports.facilityReadinessSchema = exports.readinessGapSchema = exports.readinessCheckSchema = void 0;
/**
 * `RPM-062` — a tenant's readiness: five checks per building with a current profile, read from
 * `v_facility_readiness`, each failing check named in the words the nurse sees (`J-283`).
 *
 * READINESS REFUSES NOTHING BUT AN ENTRY AT A BUILDING WITH NO ACTIVE CARE UNIT (`SPEC-D-13`). Every
 * other failing building still has its alerts accepted and worked, with the obligation recorded
 * `UNMET` and the reason named (`RPM-035`); this list is how an administrator sees that before any
 * alert does.
 */
const zod_1 = require("zod");
/** The view's five checks, as they are named on the wire. */
exports.readinessCheckSchema = zod_1.z.enum([
    "hasProfile",
    "hasRouting",
    "hasActiveCareUnit",
    "hasCriticalDestination",
    "hasSummarySchedule",
]);
/** One missing thing: the check, the sentence, and the screen that fixes it. */
exports.readinessGapSchema = zod_1.z.object({
    check: exports.readinessCheckSchema,
    gap: zod_1.z.string(),
    fixAt: zod_1.z.string(),
});
exports.facilityReadinessSchema = zod_1.z.object({
    facilityId: zod_1.z.string().min(1).max(20),
    name: zod_1.z.string(),
    ready: zod_1.z.boolean(),
    gaps: zod_1.z.array(exports.readinessGapSchema),
});
exports.readinessListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.facilityReadinessSchema),
});
/** `?tenantId=` — the block's API row; when sent, it must be the caller's own tenant. */
exports.readinessQuerySchema = zod_1.z.object({ tenantId: zod_1.z.uuid().optional() });
/**
 * Each check's gap, in the words the nurse meets when an alert runs into it, and where it is fixed.
 * The order is the order a building is set up in.
 */
exports.READINESS_GAPS = {
    hasProfile: {
        gap: "This building has no valid time zone, so a typed time cannot be read.",
        fixAt: "/admin/facility-zones",
    },
    hasActiveCareUnit: {
        gap: "This building has no active care unit, so a reading cannot be saved here.",
        fixAt: "/admin/care-units",
    },
    hasRouting: {
        gap: "How this building is contacted is not set up, or is held for review, so its alerts record the obligation as unmet.",
        fixAt: "/admin/facility-routing",
    },
    hasCriticalDestination: {
        gap: "Nobody in this building's directory can be reached for a critical: there is no active callable phone and no alert email.",
        fixAt: "/admin/routing-directory",
    },
    hasSummarySchedule: {
        gap: "This building's summary schedule is incomplete: the weekly day and time, and the daily times where concerning alerts go to the summary.",
        fixAt: "/admin/facility-routing",
    },
};
//# sourceMappingURL=rpm-readiness.js.map